module.exports = __webpack_public_path__ + "static/media/error.b6deed5c.svg";